// extracted by mini-css-extract-plugin
export default {"cls1":"SearchUpsell-cls1___0f58f3db05b11b8a632","cls2":"SearchUpsell-cls2__dd4468c3ad28479b8384 SearchUpsell-cls1___0f58f3db05b11b8a632"};